/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_D2tInputs */

const en_mk_sol_startup_d2t = /** @type {(inputs: Mk_Sol_Startup_D2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Midday: the agent drafts the feature spec`)
};

const id_mk_sol_startup_d2t = /** @type {(inputs: Mk_Sol_Startup_D2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siang: spesifikasi fitur disusun agen`)
};

/**
* | output |
* | --- |
* | "Midday: the agent drafts the feature spec" |
*
* @param {Mk_Sol_Startup_D2tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_d2t = /** @type {((inputs?: Mk_Sol_Startup_D2tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_D2tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_d2t(inputs)
	return en_mk_sol_startup_d2t(inputs)
});